import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import LiveStream from './pages/LiveStream';
import Events from './pages/Events';
import Word from './pages/Word';
import SmallGroups from './pages/SmallGroups';
import Ministries from './pages/Ministries';
import About from './pages/About';
import Donations from './pages/Donations';
import Auth from './pages/Auth';
import Profile from './pages/Profile';
import PrayerRequests from './pages/PrayerRequests';
import LocationPage from './pages/LocationPage';
import Notifications from './pages/Notifications';
import Bible from './pages/Bible';
import BibleQuiz from './pages/BibleQuiz';
import ChristianTips from './pages/ChristianTips';
import Testimonials from './pages/Testimonials';
import SpiritualCounselor from './pages/SpiritualCounselor';
import SpiritualGuidance from './pages/SpiritualGuidance';
import Cursos from './pages/Cursos';
import CursoDetalhe from './pages/CursoDetalhe';
import CursoAvaliacao from './pages/CursoAvaliacao';
import CursoCertificado from './pages/CursoCertificado';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import UserDashboard from './pages/UserDashboard';
import FaithJourney from './pages/FaithJourney';

// Admin Pages
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminUsers from './admin/pages/AdminUsers';
import AdminEvents from './admin/pages/AdminEvents';
import AdminLiveStreams from './admin/pages/AdminLiveStreams';
import AdminMessages from './admin/pages/AdminMessages';
import AdminPrayers from './admin/pages/AdminPrayers';
import AdminNotifications from './admin/pages/AdminNotifications';
import AdminBackup from './admin/pages/AdminBackup';
import AdminLogs from './admin/pages/AdminLogs';
import AdminSettings from './admin/pages/AdminSettings';
import AdminChristianTips from './admin/pages/AdminChristianTips';
import AdminTestimonials from './admin/pages/AdminTestimonials';
import AdminSpiritualGuidance from './admin/pages/AdminSpiritualGuidance';

// Admin Global Pages
import AdminGlobalDashboard from './admin/pages/global/AdminGlobalDashboard';
import AdminIgrejas from './admin/pages/global/AdminIgrejas';
import AdminGlobalUsers from './admin/pages/global/AdminUsers';
import AdminGlobalEvents from './admin/pages/global/AdminEvents';
import AdminGlobalNotifications from './admin/pages/global/AdminNotifications';
import AdminGlobalPrayerRequests from './admin/pages/global/AdminPrayerRequests';
import AdminGlobalTestimonials from './admin/pages/global/AdminTestimonials';
import AdminGlobalCourses from './admin/pages/global/AdminCourses';

// Admin Local Pages
import AdminLocalDashboard from './admin/pages/local/AdminLocalDashboard';

import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Global Routes */}
        <Route path="/admin-global" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/igrejas" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminIgrejas />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/users" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalUsers />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/events" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalEvents />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/notifications" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalNotifications />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/prayers" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalPrayerRequests />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/testimonials" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalTestimonials />
          </ProtectedRoute>
        } />
        <Route path="/admin-global/courses" element={
          <ProtectedRoute requireGlobalAdmin>
            <AdminGlobalCourses />
          </ProtectedRoute>
        } />

        {/* Admin Local Routes */}
        <Route path="/admin-local" element={
          <ProtectedRoute requireLocalAdmin>
            <AdminLocalDashboard />
          </ProtectedRoute>
        } />

        {/* Legacy Admin Routes */}
        <Route path="/admin" element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/users" element={
          <ProtectedRoute requireAdmin>
            <AdminUsers />
          </ProtectedRoute>
        } />
        <Route path="/admin/events" element={
          <ProtectedRoute requireAdmin>
            <AdminEvents />
          </ProtectedRoute>
        } />
        <Route path="/admin/live" element={
          <ProtectedRoute requireAdmin>
            <AdminLiveStreams />
          </ProtectedRoute>
        } />
        <Route path="/admin/messages" element={
          <ProtectedRoute requireAdmin>
            <AdminMessages />
          </ProtectedRoute>
        } />
        <Route path="/admin/prayers" element={
          <ProtectedRoute requireAdmin>
            <AdminPrayers />
          </ProtectedRoute>
        } />
        <Route path="/admin/notifications" element={
          <ProtectedRoute requireAdmin>
            <AdminNotifications />
          </ProtectedRoute>
        } />
        <Route path="/admin/christian-tips" element={
          <ProtectedRoute requireAdmin>
            <AdminChristianTips />
          </ProtectedRoute>
        } />
        <Route path="/admin/testimonials" element={
          <ProtectedRoute requireAdmin>
            <AdminTestimonials />
          </ProtectedRoute>
        } />
        <Route path="/admin/spiritual-guidance" element={
          <ProtectedRoute requireAdmin>
            <AdminSpiritualGuidance />
          </ProtectedRoute>
        } />
        <Route path="/admin/backup" element={
          <ProtectedRoute requireAdmin>
            <AdminBackup />
          </ProtectedRoute>
        } />
        <Route path="/admin/logs" element={
          <ProtectedRoute requireAdmin>
            <AdminLogs />
          </ProtectedRoute>
        } />
        <Route path="/admin/settings" element={
          <ProtectedRoute requireAdmin>
            <AdminSettings />
          </ProtectedRoute>
        } />

        {/* Legal Document Pages */}
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* User Dashboard */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <UserDashboard />
          </ProtectedRoute>
        } />
        
        {/* Faith Journey */}
        <Route path="/faith-journey" element={
          <ProtectedRoute>
            <FaithJourney />
          </ProtectedRoute>
        } />

        {/* Public Routes */}
        <Route path="/auth" element={<Auth />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="live" element={<LiveStream />} />
          <Route path="events" element={<Events />} />
          <Route path="word" element={<Word />} />
          <Route path="bible" element={<Bible />} />
          <Route path="bible-quiz" element={<BibleQuiz />} />
          <Route path="christian-tips" element={<ChristianTips />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="spiritual-counselor" element={<SpiritualCounselor />} />
          <Route path="spiritual-guidance" element={
            <ProtectedRoute>
              <SpiritualGuidance />
            </ProtectedRoute>
          } />
          <Route path="location" element={<LocationPage />} />
          <Route path="small-groups" element={<SmallGroups />} />
          <Route path="ministries" element={<Ministries />} />
          <Route path="about" element={<About />} />
          <Route path="donations" element={<Donations />} />
          <Route path="prayer" element={
            <ProtectedRoute>
              <PrayerRequests />
            </ProtectedRoute>
          } />
          <Route path="profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="notifications" element={<Notifications />} />
          <Route path="cursos" element={<Cursos />} />
          <Route path="cursos/:cursoId" element={
            <ProtectedRoute>
              <CursoDetalhe />
            </ProtectedRoute>
          } />
          <Route path="cursos/avaliacao" element={
            <ProtectedRoute>
              <CursoAvaliacao />
            </ProtectedRoute>
          } />
          <Route path="cursos/certificado" element={
            <ProtectedRoute>
              <CursoCertificado />
            </ProtectedRoute>
          } />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;